import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Login from '~pages/auth/login';
import { LogoMain as LogoMainIcon } from 'common/components/svgs';
import ForgotPassword from '~pages/auth/forgot-password';
import ForgotPasswordSuccessful from '~pages/auth/forgot-password-successful';
import ResetPassword from '~pages/auth/reset-password';
import generatePath from '~settings/routing';
import loginImg from '~global-css/imgs/login-image.png';
import jwtDecode from 'jwt-decode';

const mapStateToProps = state => ({
  token: state.auth.getIn(['base', 'token']),
  state: state?.auth.get('auth').currentRoleSlug,
});

@connect(mapStateToProps)
export default class Auth extends React.Component {
  render() {
    if (this.props.token) {
      const search = queryString.parse(this.props.location.search);
      // TODO redirect to dashboard if logged in
      let url = 'properties';
      if (jwtDecode(this.props.token)?.roles?.indexOf('agent_admin') > -1) {
        url = 'agent';
      }

      if (jwtDecode(this.props.token)?.roles?.indexOf('bc') > -1) {
        url = 'students';
      }
      return <Redirect to={search.redirectUrl || generatePath(url)} />;
    }
    return (
      <section className="auth">
        <img className="auth__login-image" src={loginImg} alt="login" />
        <div className="auth__container">
          <Route path="/login" component={Login} />
          <Route path="/forgot-password/:email?" exact component={ForgotPassword} />
          <Route path="/forgot-password/:email/success" component={ForgotPasswordSuccessful} />
          <Route path="/set-password" component={ResetPassword} />
        </div>
        <LogoMainIcon className="auth__logo-main" />
      </section>
    );
  }
}

Auth.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  token: PropTypes.string,
};

Auth.defaultProps = {
  location: {
    search: '',
  },
  token: '',
};
